// eslint-disable-next-line import/prefer-default-export
export const INVOICING_EN = {
  // common
  Cancel: 'Cancel',
  Accept: 'Accept',

  See: 'See',
  title: 'Invoicing',
  CompanysPlans: "Companys' plans",
  All: 'All',
  placeholderSearchCompany: 'Search company',
  CreateNewInvoice: 'Create new invoice',
  Company: 'Company',
  Plan: 'Plan',
  InitialDate: 'Initial date',
  ExpirationDate: 'Expiration date',
  Actions: 'Actions',

  // modalCreate
  AddInvoice: 'Add invoice',
  WhoAddressedTo: 'Who is the invoice addressed to?',
  placeholderSearchTemplates: 'Search templates',
  WhichMonth: 'Which month?',
  RequiresCharge: 'Requires charge',
  DropAFileHere: 'Drop a file here',
  AddEmail: 'Add email',
  AddEmailSecondary: 'Add email secondary',

  // modalInvoicesList
  InvoicesList: 'Invoices list',
  Name: 'Name',
  Type: 'Type',
  ExpeditionDate: 'Expedition date',
  EntryDate: 'Entry date',
  NoInvoices: 'No assigned invoices',

  // Notifications
  InvoicesAdded: 'Invoices added',
  OnlyPdfXml: 'Only .pdf and .xml extensions are allowed',
  MustUploadFiles: 'You  must upload the required files',
  MustSelectCompany: 'Please select a company',
  ErrorUploadingFile: 'An error occurred while uploading the file',

  // new accounts
  aggree: 'Grant access',
  reject: 'Reject acceso',
  empty: 'Without the information',
  textAgree: 'Are you sure you want to grant access to this account?',
  textReject: 'Are you sure you want to reject access to this account?',
  agree: 'I agree',
  cancel: 'Cancel',
  confirm: 'Confirm',
  textAccept: 'Approval of companies',
  companyName: 'Company',
  phone: 'Phone',
  actions: 'Actions',
  optionFilter: 'Others functions',
  noData: 'There is no data available',
  dateAction: 'Date',
  txtPendingCompanies: 'Pending',
  txtAcceptedCompanies: 'Accepted',
  txtRejectedCompanies: 'Rejected',
  txtResponsible: 'Responsible',
  txtNameCompany: 'Company name',
};
